import React from 'react'
import styled from 'styled-components'
import ScrollContainer from 'react-indiana-drag-scroll'

const Container = styled(ScrollContainer)`
  position: relative;
  width:100%;
  z-index: 1;
  margin: ${props => props.topBarOffset ? '86px' : '60px'} auto 0 auto;
  height: calc(100vh - ${props => props.topBarOffset ? '86px' : '60px'});
  overflow: auto;
  cursor: grab;
  background-color: ${props => props.theme.pageBg};
`

const DraggableContainer = ({topBarOffset, children}) => (
    <Container topBarOffset={topBarOffset}>{children}</Container>
)

export default DraggableContainer
